import React, { useState } from 'react';
import { Capacitor } from '@capacitor/core';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import TopNav from './components/TopNav';
import MobileShell from './components/MobileShell';
import Dashboard from './pages/Dashboard';
import LessonPlans from './pages/LessonPlans';
import AcademicCalendar from './pages/AcademicCalendar';
import TeacherSchedule from './pages/TeacherSchedule';
import CoursePlanning from './pages/CoursePlanning';
import Attendance from './pages/Attendance';
import AttendanceSearch from './pages/AttendanceSearch';
import ClassStatus from './pages/ClassStatus';
import AbsenceStatus from './pages/AbsenceStatus';
import MyProfile from './pages/MyProfile';
import StudentHours from './pages/StudentHours';
import AnnualAssignment from './pages/AnnualAssignment';
import SupplementaryAssignment from './pages/SupplementaryAssignment';
import TeacherManagement from './pages/TeacherManagement';
import SubjectManagement from './pages/SubjectManagement';
import MaterialManagement from './pages/MaterialManagement';
import StudentManagement from './pages/StudentManagement';
import Chat from './pages/Chat';
import YoutubeMaterial from './pages/YoutubeMaterial';
import EducationDays from './pages/EducationDays';
import ClassHours from './pages/ClassHours';
import ExamScores from './pages/ExamScores';
import ExamResults from './pages/ExamResults';
import ExamSummary from './pages/ExamSummary';
import ComingSoon from './pages/ComingSoon';
import ATOCertificate from './pages/ATOCertificate';
import StandardRegulations from './pages/StandardRegulations';
import TeacherQualifications from './pages/TeacherQualifications';
import CompletionCertificate from './pages/CompletionCertificate';

function Shell() {
  const { user, loading } = useAuth();
  const [active, setActive] = useState('dashboard');

  if (loading) {
    return <div className="app-loading">불러오는 중...</div>;
  }

  if (!user) {
    return <Login />;
  }

  if (Capacitor.isNativePlatform()) {
    return <MobileShell />;
  }

  const renderPage = () => {
    switch (active) {
      case 'dashboard':
        return <Dashboard />;
      case 'academic-calendar':
        return <AcademicCalendar />;
      case 'teacher-schedule':
        return <TeacherSchedule />;
      case 'course-planning':
        return <CoursePlanning />;
      case 'lesson-plans':
        return <LessonPlans />;
      case 'assignments':
        return <AnnualAssignment />;
      case 'supplementary-assignment':
        return <SupplementaryAssignment />;
      case 'attendance':
        return <Attendance />;
      case 'attendance-search':
        return <AttendanceSearch />;
      case 'class-status':
        return <ClassStatus />;
      case 'absence-status':
        return <AbsenceStatus />;
      case 'student-hours':
        return <StudentHours />;
      case 'education-days':
        return <EducationDays />;
      case 'class-hours':
        return <ClassHours />;
      case 'exam-scores':
        return <ExamScores onNavigate={setActive} />;
      case 'exam-summary':
        return <ExamSummary />;
      case 'ato-certificate':
        return <ATOCertificate />;
      case 'training-standard':
        return <StandardRegulations key="TOS" stdtype="TOS" />;
      case 'education-standard':
        return <StandardRegulations key="ESR" stdtype="ESR" />;
      case 'teacher-qualification':
        return <TeacherQualifications />;
      case 'completion-certificate':
        return <CompletionCertificate />;
      case 'data-files':
        return <ComingSoon title="자료관리" />;
      case 'exam-results':
        return <ExamResults onNavigate={setActive} />;
      case 'subject-management':
        return <SubjectManagement />;
      case 'material-management':
        return <MaterialManagement />;
      case 'youtube-material':
        return <YoutubeMaterial />;
      case 'teacher-management':
        return <TeacherManagement />;
      case 'student-management':
        return <StudentManagement />;
      case 'my-profile':
        return <MyProfile />;
      case 'chat':
        return <Chat />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="app-shell">
      <TopNav active={active} onNavigate={setActive} />
      <main className="app-content">{renderPage()}</main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}

export default App;
